// authSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { login, getCurrentUser, register, changePassword as changePasswordApi } from '../../api/auth'

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  isLoading: false,
  isSuccess: false,
  error: null
};

export const loginUser = createAsyncThunk(
    'login',
    async (params, thunkApi) => {
        try {
            const response = await login(params);
            // Throw Err
            if(response?.status && (response.status !== 200) ){
                throw response
            }
            if (response.data?.role === 'admin') {
                return thunkApi.rejectWithValue('Your sign-in attempt could not be completed.');
            }
            return response.data;
        } catch (err) {
            const backendMsg = err?.response?.data?.error || err?.response?.data?.message
            return thunkApi.rejectWithValue(backendMsg || err?.message || 'Something went wrong');
        }
    }
);

export const getMe = createAsyncThunk(
    'getMe',
    async (params, thunkApi) => {
        try {
            const state = thunkApi.getState();
            const authState = state.auth;
            const response = await getCurrentUser(authState.token);
            // Throw Err
            if(response?.status && response.status !== 200){
                throw response
            }
            return response.data;
        } catch (err) {
            const backendMsg = err?.response?.data?.error || err?.response?.data?.message
            return thunkApi.rejectWithValue(backendMsg || err?.message || 'Something went wrong');
        }
    }
);


export const logout = createAsyncThunk(
    'logout',
    async (_, thunkApi) => {
        try {
            return {};
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    });

export const signup = createAsyncThunk(
    'signup',
    async (params, thunkApi) => {
        try {
            const response = await register(params);
            // Throw Err
            if(response?.status && (response.status !== 200) ){
                throw response
            }
            return response.data;
        } catch (err) {
            const backendMsg = err?.response?.data?.error || err?.response?.data?.message
            return thunkApi.rejectWithValue(backendMsg || err?.message || 'Something went wrong');
        }
    })

export const changePassword = createAsyncThunk(
  'changePassword',
  async (params, thunkApi) => {
    try {
      const state = thunkApi.getState();
      const authState = state.auth;
    //   console.log("Change Password Params:", authState, params);
      const response = await changePasswordApi(
        {
          currentPassword: params.currentPassword,
          newPassword: params.newPassword
        },
        authState.token
      );
      return response;
    } catch (err) {
      const backendMsg = err?.response?.data?.error || err?.response?.data?.message
      return thunkApi.rejectWithValue(backendMsg || err?.message || 'Something went wrong');
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuthStatus: (state) => {
      state.isSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Handle login cases
    builder
        .addCase(loginUser.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(loginUser.fulfilled, (state, action) => {
            // console.log("Fulfilled Case");
            state.isLoading = false;
            state.user = action.payload;
            state.token = action.payload?.token;
            state.isSuccess = false;
            state.isAuthenticated=true;
            state.error = null;
        })
        .addCase(loginUser.rejected, (state, action) => {
            state.isLoading = false;
            state.isAuthenticated = false;
            state.user = null;
            state.token =  null;
            state.error = action.payload;
        });

    // Handle getMe cases
    builder
        .addCase(getMe.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getMe.fulfilled, (state, action) => {
            // console.log("Action.Payload in getUSer:", action.payload)
            state.isLoading = false;
            state.user = action.payload;
            state.token = action.payload?.token;
            state.isSuccess = true;
            state.isAuthenticated=true;
            state.error = null;
        })
        .addCase(getMe.rejected, (state, action) => {
            state.isLoading = false;
            state.isAuthenticated = false;
            state.user = null;
            state.token =  null;
            state.error = action.payload;
        });

    // Handle logout cases
    builder
        .addCase(logout.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(logout.fulfilled, (state) => {
            state.isLoading = false;
            state.isAuthenticated=false;
            state.isSuccess = true;
            state.user = null;
            state.token = null; 
        })
        .addCase(logout.rejected, (state,action) => {
            state.isLoading = false;
            state.error = action.payload.message;
        });

    //Handle SignUp Cases
    builder
        .addCase(signup.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(signup.fulfilled, (state, action) => {
            state.isLoading = false;
            state.user = action.payload;
            state.token = action.payload?.token;
            state.isSuccess = true;
            state.isAuthenticated=true;
            state.error = null;
        })
        .addCase(signup.rejected, (state, action) => {
            state.isLoading = false;
            state.isAuthenticated = false;
            state.user = null;
            state.token =  null;
            state.error = action.payload;
        });
    
    // Handle changePassword cases
    builder
      .addCase(changePassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
},
});

// export const { login, logout } = authSlice.actions;
export const selectAuth = (state) => state.auth;
export const { clearAuthStatus } = authSlice.actions;
export default authSlice.reducer;

